import { Children, cloneElement, memo, useCallback, useMemo, } from 'react';
import { useMintedField } from '../useMintedField/useMintedField';
const AutocompleteAddressField = ({ children, }) => {
    const mintedFieldProps = (useMintedField({
        inputValue: undefined,
        isCheckboxElement: false,
        isMultipleElement: false,
        name: children.props.name || '',
        /* eslint-disable-next-line deprecation/deprecation */
        onChange: children.props.onChange,
        onVisit: children.props.onBlur,
    }));
    const onUpdate = (useCallback((data) => {
        if (data.type === 'input_change') {
            mintedFieldProps.onChange(data);
        }
    }, [
        mintedFieldProps,
    ]));
    const childProps = (useMemo(() => (Object.assign(Object.assign({}, mintedFieldProps), { onUdpate: onUpdate })), [
        mintedFieldProps,
        onUpdate,
    ]));
    return (cloneElement((Children
        .only(children)), childProps));
};
const MemoizedAutocompleteAddressField = memo(AutocompleteAddressField);
export { MemoizedAutocompleteAddressField as AutocompleteAddressField };
